import { _User } from "../../../js/parsegenerated";

/**
 * Returns the pretty username.
 * @param user
 * @returns
 */
export function getUsername(user: _User) {
  let username = "";
  if (user?.get("firstname") && user?.get("lastname")) {
    username = user?.get("firstname") + " " + user?.get("lastname");
  } else if (user?.get("name")) {
    username = user?.get("name");
  } else {
    username = user?.getUsername();
  }
  return username;
}
